import isFQDN from 'validator/es/lib/isFQDN';
import isIP from 'validator/es/lib/isIP';
import toString from 'lodash/toString';
import { Validator } from 'components/LWForm';

export const required: Validator = (value) => {
	if (!value) {
		return 'This field is required';
	}
	return '';
};

export const validateDomain: Validator = (domainValue) => {
	if (domainValue && !isFQDN(toString(domainValue))) {
		return 'Please enter a valid domain name';
	}
	return '';
};

export const validateSubDomain: Validator = (domainValue) => {
	if (domainValue && !isFQDN(toString(domainValue), { require_tld: false })) {
		return 'Please enter a valid subdomain name';
	}
	return '';
};

export const validateOppId: Validator = (oppId) => {
	const stringOppId = toString(oppId);
	const isValid =
		/006[A-Za-z0-9]{12,15}/.test(stringOppId) && stringOppId.length <= 18;
	return !isValid ? 'Please enter a valid opportunity ID' : '';
};

export const validatePhoneNumber: Validator = (phoneNumber) => {
	const stringPhoneNumber = toString(phoneNumber);
	const isValid = /^[0-9extnsio.,()+ -]{2,25}$/i.test(stringPhoneNumber);
	return !isValid ? 'Please enter phone number in a valid format' : '';
};

export const isIpV4: Validator = (ip) => {
	if (typeof ip !== 'string') {
		return 'Please enter a valid IPv4 address';
	}

	return !isIP(ip, 4) ? 'Please enter a valid IPv4 address' : '';
};

export const isIpV6: Validator = (ip) => {
	if (typeof ip !== 'string') {
		return 'Please enter a valid IPv6 address';
	}

	return !isIP(ip, 6) ? 'Please enter a valid IPv6 address' : '';
};

export const isValidIp: Validator = (ip) => {
	if (typeof ip !== 'string') {
		return 'Please enter a valid IPv4 or IPv6 address';
	}

	return !isIP(ip) ? 'Please enter a valid IPv4 or IPv6 address' : '';
};
